module.exports = __webpack_public_path__ + "img/btn上@2x.d10326b2.png";